import moduleMall from './module'

export default [
  {
    path: '*',
    name: 'login',
    component: resolve => require(['@/page/login.vue'], resolve)
  },
  {
    path: '/mainNav',
    name: 'mainNav',
    component: resolve => require(['@/page/mainNav.vue'], resolve),
    children: [
      ...moduleMall
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/index.js